import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

const Shell = ({ children }) => (
  <div className="min-h-screen bg-background grain"><Navbar /><div className="max-w-xl mx-auto px-6 pt-40 pb-20 text-center">{children}</div></div>
);

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setTimeout(() => navigate(`/booking/${data.booking_code}`), 1500);
          return;
        }
        if (["expired", "failed"].includes(data.payment_status) || attempts > 10) { setStatus("failed"); return; }
      } catch { if (attempts > 10) { setStatus("failed"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <Shell>
      {status === "checking" && <div className="fade-up"><Loader2 className="w-12 h-12 animate-spin text-[#E63946] mx-auto mb-5" /><h1 className="font-display text-2xl font-bold uppercase">Verifica pagamento…</h1><p className="text-muted-foreground mt-2">Attendi un istante.</p></div>}
      {status === "paid" && <div className="fade-up"><CheckCircle2 className="w-14 h-14 text-[#10B981] mx-auto mb-5" /><h1 className="font-display text-2xl font-bold uppercase">Pagamento riuscito!</h1><p className="text-muted-foreground mt-2">Ti stiamo portando al voucher…</p></div>}
      {status === "failed" && <div className="fade-up"><XCircle className="w-14 h-14 text-[#E63946] mx-auto mb-5" /><h1 className="font-display text-2xl font-bold uppercase">Pagamento non confermato</h1><Link to="/cars"><Button className="mt-6 bg-[#E63946] hover:bg-[#D62828] text-white rounded-full px-8">Torna al parco auto</Button></Link></div>}
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell>
      <div className="fade-up">
        <XCircle className="w-14 h-14 text-[#F59E0B] mx-auto mb-5" />
        <h1 className="font-display text-2xl font-bold uppercase">Pagamento annullato</h1>
        <p className="text-muted-foreground mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Link to="/cars"><Button className="mt-6 bg-[#E63946] hover:bg-[#D62828] text-white rounded-full px-8" data-testid="cancel-back-btn">Torna al parco auto</Button></Link>
      </div>
    </Shell>
  );
}
